import type { SmartSort, IntendedDisplay } from '@iheartjane/dm-sdk';
import type { BannerCustomImageAdSlide } from '@iheartjane/menu';

import type { AlgoliaProduct } from '@jane/search/types';

interface BuildCustomImageAdSlideArgs {
  instance: SmartSort<AlgoliaProduct>;
  intendedDisplay: IntendedDisplay;
  onImageClick?: (brandName: string) => void;
}

export const buildCustomImageAdSlide = ({
  instance,
  intendedDisplay,
  onImageClick,
}: BuildCustomImageAdSlideArgs): BannerCustomImageAdSlide | undefined => {
  if (!instance.products.length) {
    return undefined;
  }

  const customImageData = instance.customImages.find(
    (image) => image.intendedDisplay === intendedDisplay
  );

  if (!customImageData) {
    return undefined;
  }

  return {
    customImageData,
    id: 'carousel-image-ad',
    kind: 'customImageAd',
    onImageClick,
    products: instance.products.map((product) => {
      const { attributes } = product;

      return {
        aggregate_rating: attributes.aggregate_rating ?? 0,
        brand: attributes.brand ?? '',
        category: attributes.category ?? '',
        clickHandler: () => void product.click(),
        image_urls: attributes.image_urls ?? [],
        name: attributes.name,
        pdpUrl: `/products/${attributes.product_id}`,
        product_id: attributes.product_id,
        review_count: attributes.review_count ?? 0,
      };
    }),
  };
};
